class carouselCss extends HTMLElement {
    constructor() {
        super();

        this.scrollContainer = this.scrollContainer.bind(this);
        this.checkArrowsAndPagination = this.checkArrowsAndPagination.bind(this);
    }

    connectedCallback() {
        this.leftArrow = this.querySelector('.carousel-arrow-left');
        this.rightArrow = this.querySelector('.carousel-arrow-right');
        this.container = this.querySelector('.product-card__slider--css');
        this.paginationDots = this.querySelectorAll('.product-card__slider--pagination-dots');

        this.slides = this.container.querySelectorAll('.product-card__slider--image');

        this.querySelectorAll('.carousel-arrow').forEach((element) => {
            element.addEventListener('click', () => {
                this.scrollContainer(element)
            })
        })

        /* Ecoute de l'event scroll sur le slider */
        this.container.addEventListener('scroll', this.checkArrowsAndPagination);
    }

    scrollContainer(element){
        const scrollAmount = this.offsetWidth;

        if (element.classList.contains('carousel-arrow-left')) {
            this.container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
            this.container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }

        setTimeout(this.checkArrowsAndPagination, 300);
    }

    checkArrowsAndPagination() {
        const scrollLeft = this.container.scrollLeft;
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

        /* Gestion des fleches */
        if (scrollLeft <= 0) {
            this.leftArrow.querySelector('.carousel-arrow--wrapper').classList.add('hidden');
        } else {
            this.leftArrow.querySelector('.carousel-arrow--wrapper').classList.remove('hidden');
        }

        if (scrollLeft >= maxScrollLeft - 1) {
            this.rightArrow.querySelector('.carousel-arrow--wrapper').classList.add('hidden');
        } else {
            this.rightArrow.querySelector('.carousel-arrow--wrapper').classList.remove('hidden');
        }


        /* Gestion de la pagination */
        const sliderRect = this.container.getBoundingClientRect();
        const centerX = sliderRect.left + sliderRect.width / 2;

        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, i) => {
            const slideRect = slide.getBoundingClientRect();
            const slideCenter = slideRect.left + slideRect.width / 2;
            const distance = Math.abs(centerX - slideCenter);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = i;
            }
        });

        this.paginationDots.forEach((dot, i) => {
            dot.classList.toggle('active', i === closestIndex);
        });
    }

}

customElements.define('w3-carousel-css', carouselCss);